/**
 * Application version configuration
 *
 * The version is injected at build time from the VERSION file
 * via Vite's define feature.
 */

// Declare the global constant injected by Vite
declare const __APP_VERSION__: string;

/**
 * Current application version (e.g., "0.1.0")
 * Read from VERSION file at build time
 */
export const APP_VERSION: string = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.1.0';

/**
 * Get formatted version string with optional prefix
 */
export function getVersionString(prefix = 'v'): string {
  return `${prefix}${APP_VERSION}`;
}
